import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { FIRST_LINE_CELL_STYLE } from './deliveryAgencyTableCells';

import type { TypeShippingLabelCancelFailure } from '~/types/delivery-agency.types';

const getDeliveryAgencyTrackingCancelFailColumnDefs = () => {
  const columnDefs: TypeTableColumn<TypeShippingLabelCancelFailure>[] = [
    {
      id: 'no',
      header: 'No',
      cell: ({ row }) => row.index + 1,
      size: 72,
      meta: { cellStyle: FIRST_LINE_CELL_STYLE },
    },
    {
      accessorKey: 'outboundCode',
      header: '출고 번호',
      size: 160,
      meta: { cellStyle: FIRST_LINE_CELL_STYLE },
    },
    {
      accessorKey: 'clientOrderCodes',
      header: '판매처 주문번호',
      minSize: 620,
      cell: ({ row }) => row.original.clientOrderCodes?.join(', ') ?? '-',
      meta: { flex: true, overflow: 'wrap' },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyTrackingCancelFailColumnDefs;
